import { CombinedAudiencePlatformLabel } from '../../constants/index';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  subText: {
    color: '#685d6f',
    fontSize: 12,
    marginRight: 5,
  },
}));

const RenderEstimatedAudienceSize = ({ lalAudienceCount }) => {
  const classes = useStyles();
  if (!lalAudienceCount || !lalAudienceCount?.length === 0) {
    return null;
  }

  return (
    <div>
      {CombinedAudiencePlatformLabel.map(item => {
        const audienceCount = lalAudienceCount?.find(
          a => a.idType === item.TYPE
        )?.audienceCount;
        const lowerBoundRange = audienceCount
          ? Math.round(audienceCount * 0.9)
          : 0;
        const upperBoundRange = audienceCount
          ? Math.round(audienceCount * 1.1)
          : 0;
        return (
          <div key={item.PRIMARY_TEXT}>
            <>
              <span className='body'>
                <b>{item.PRIMARY_TEXT} </b>
                <span className={classes.subText}>{item.SECONDARY_TEXT}:</span>
                {lowerBoundRange?.toLocaleString() || 0}
                <span> - </span>
                {upperBoundRange?.toLocaleString() || 0}
              </span>
            </>
          </div>
        );
      })}
    </div>
  );
};

export default RenderEstimatedAudienceSize;
